/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'
import { Random } from "random-js";
import axios from '@/axios.js'
import con from "@/firebase/firebaseInit.ts";
import Handlebars from 'handlebars';
import AddToCalendar from 'vue-add-to-calendar'
import firebase from 'firebase';
import ls from "@/common/localStorage"

Vue.use(AddToCalendar);
//var cn = 'OA_UAT_C1591205467009E1591206650065';
var cn = ls.getSessionEventCollectionName();
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var Sesion_EventAccessType = ls.getSessionValueByKey('Sesion_EventAccessType');
var attendeeRef = con.eventDB.collection(cn).doc("AttendeeList").collection("Attendees");
var maitmplateRef = con.eventDB.collection(cn).doc("mailtpl").collection("ReminderMail");
var eventRef = con.eventDB.collection(cn).doc("EventInfo");
var clientRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id);
var userEventsRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id).collection('UserEvents');
var speakerRef = con.eventDB.collection(cn).doc('SpeakerList').collection('Speakers')
var ClientCollectionName = '/OA_UAT';
var Regref = con.eventDB.collection(cn).doc("FormList").collection("RegistrationForms");
var regTicketTypes = con.eventDB.collection(cn).doc("RegistrationTicketList").collection("RegistrationTicketTypes");
var mailTemplateAccouncementRef = con.eventDB.collection(cn).doc("mailtpl").collection("AnnouncementMail");

var AddSingleAttendeeAPI = con.AddSingleAttendeeAPI;
var AddAttendeeAPI = con.AddAttendeeAPI;

var storageRef = con.storageRef;
var SINGLEEMAILAPIURL = con.SINGLEEMAILAPIURL;
var BULKEMAILAPIURL = con.BULKEMAILAPIURL;
var BULKMAILAPINEW = con.BULKMAILAPINEW;
var DeleteAttendeeURL = con.DeleteAttendeeURL;
var DeleteAttendeeApiKey = con.DeleteAttendeeApiKey;
var ResetPasswordForUserAPI = con.ResetPasswordForUserAPI;
var CheckUserValidAPI = con.CheckUserValidAPI;
var UpdateUserAPI = con.UpdateUserAPI;
var SearchAttendees = con.SearchAttendees;
var generateQR = con.generateQR;
var ResetPasswordForCheckinUserAPI = con.ResetPasswordForCheckinUserAPI;
var defaultPassword = con.defaultPassword;

export default {
    reInitAttendeeSession() {
        debugger;
        cn = ls.getSessionEventCollectionName();
        Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
        Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
        attendeeRef = con.eventDB.collection(cn).doc("AttendeeList").collection("Attendees");
        maitmplateRef = con.eventDB.collection(cn).doc("mailtpl").collection("ReminderMail");
        eventRef = con.eventDB.collection(cn).doc("EventInfo");
        clientRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id);
        userEventsRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id).collection('UserEvents');
        storageRef = con.storageRef;
        mailTemplateAccouncementRef = con.eventDB.collection(cn).doc("mailtpl").collection("AnnouncementMail");
    },
    // addItem({ commit }, item) {
    //   return new Promise((resolve, reject) => {
    //     axios.post("/api/data-list/products/", {item: item})
    //       .then((response) => {
    //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
    //         resolve(response)
    //       })
    //       .catch((error) => { reject(error) })
    //   })
    // },
    // DefaultRegFormSettingsJSON(context, field) {
    fetchRegistrationForms({ commit }) {
        return new Promise((resolve, reject) => {
            let markers = []
            Regref.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                resolve(markers)
            }).catch(function (error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })
        })
    },
    fetchRegistrationForm(context, FormId) {
        return new Promise((resolve, reject) => {
            let path = cn + '/Registration/DefaultRegFormSettings.JSON';
            let pathPreSignUp = cn + '/Registration/PreSignupTerms.json';
            let pathDynamicForm = cn + '/Registration/FormBuilderReg.json';
            storageRef.child(path).getDownloadURL().then(function (url) {
                axios.get(url.toString()).then(result => {
                    let DefaultRegFormSettingsJSON = result.data
                    storageRef.child(pathPreSignUp).getDownloadURL().then(function (url) {
                        axios.get(url.toString()).then(result2 => {
                            let PreSignupTermsJSON = result2.data
                            storageRef.child(pathDynamicForm).getDownloadURL().then(function (url) {
                                axios.get(url.toString()).then(result3 => {
                                    let DynamicFieldsJSON = result3.data
                                    DefaultRegFormSettingsJSON.PreSignupTerms = PreSignupTermsJSON.PreSignupTerms
                                    DefaultRegFormSettingsJSON.DynamicFields = DynamicFieldsJSON
                                    resolve(DefaultRegFormSettingsJSON)
                                }).catch(err => { reject(err) })
                            }).catch(err => { reject(err) })
                        }).catch(err => { reject(err) })
                    }).catch(err => { reject(err) })
                }).catch(err => { reject(err) })
            }).catch(err => { reject(err) })
        })
    },
    UpdateRegistrationForm(context, field) {
        let path = ClientCollectionName + '/Defaults/DefaultRegFormSettings.JSON';
        let pathPreSignUp = ClientCollectionName + '/Defaults/PreSignupTerms.json';
        let pathDynamicForm = ClientCollectionName + '/Defaults/PreSignupTerms.json';
        return new Promise((resolve, reject) => {
            storageRef.child(path).getDownloadURL().then(function (url) {
                axios.get(url.toString()).then(result => {
                    let jsonObj = null
                    let jsonPreSignupObj = null
                    let jsonDynamicForm = null
                    debugger;
                    if (typeof result.data == 'string')
                        jsonObj = eval('(' + result.data + ')');
                    else if (typeof result.data == 'object')
                        jsonObj = result.data
                    else
                        jsonObj = null
                    if (jsonObj) {
                        //------------- Basic form --------------------------------
                        //debugger;
                        debugger;
                        console.log(JSON.stringify(field));
                        jsonObj.Salutation = {};
                        jsonObj.Salutation.IsSalutationMandatory = field.IsSalutationMandatory;
                        jsonObj.Salutation.showSalutation = field.showSalutation;
                        jsonObj.Salutation.salutationDisplayLabel = field.salutationLabel;
                        //----------------------------------------------------------------
                        jsonObj.FirstName = {};
                        jsonObj.FirstName.firstNameDisplayLabel = field.FirstNameLabel;
                        jsonObj.FirstName.IsShowfName = field.showFirstName;
                        jsonObj.FirstName.IsfNameMandatory = field.IsFirstNameMandatory;
                        //------------------------------------------------------------
                        jsonObj.LastName = {};
                        jsonObj.LastName.lastNameDisplayLabel = field.LastNameLabel;
                        jsonObj.LastName.IsShowlName = field.showLastName;
                        jsonObj.LastName.IslNameMandatory = field.IsLastNameMandatory;
                        //------------------------------------------------------------
                        jsonObj.ProfilePicture = {};
                        jsonObj.ProfilePicture.ProfilePictureDisplayLabel = field.ProfilePictureLabel;
                        jsonObj.ProfilePicture.IsProfilePictureMandatory = field.IsProfilePictureMandatory;
                        jsonObj.ProfilePicture.IsShowProfilePicture = field.showProfilePicture;
                        // //------------------------------------------------------------
                        jsonObj.Email = {};
                        jsonObj.Email.IsShowEmail = field.showEmail;
                        jsonObj.Email.IsEmailMandatory = field.IsEmailMandatory;
                        jsonObj.Email.emailDisplayLabel = field.EmailLabel;
                        //------------------------------------------------------------

                        jsonObj.Company = {};
                        jsonObj.Company.IsShowCompany = field.showCompany;
                        jsonObj.Company.IsCompanyMandatory = field.IsCompanyMandatory;
                        jsonObj.Company.companyDisplayLabel = field.CompanyLabel;
                        //------------------------------------------------------------
                        jsonObj.Title = {};
                        jsonObj.Title.IsShowTitle = field.showTitle;
                        jsonObj.Title.IsTitleMandatory = field.IsTitleMandatory;
                        jsonObj.Title.TitleDisplayLabel = field.TitleLabel;
                        //------------------------------------------------------------
                        jsonObj.Mobile = {};
                        jsonObj.Mobile.IsShowMobile = field.showMobile;
                        jsonObj.Mobile.IsMobileMandatory = field.IsMobileMandatory;
                        jsonObj.Mobile.mobileDisplayLabel = field.MobileLabel;
                        //------------------------------------------------------------
                        jsonObj.Tags = {};
                        jsonObj.Tags.IsShowTags = field.showTags;
                        jsonObj.Tags.IsTagsMandatory = field.IsTagsMandatory;
                        jsonObj.Tags.tagsDisplayLabel = field.TagsLabel;
                        //------------------------------------------------------------
                        debugger;
                        jsonObj.RegistrationType = {};
                        jsonObj.RegistrationType.IsShowRegFormType = field.IsShowRegFormType;
                        jsonObj.RegistrationType.IsRegistrantTypesMandatory = field.IsRegistrantTypesMandatory;
                        jsonObj.RegistrationType.RegTypeDisplayLabel = field.RegTypeDisplayLabel;

                        // var regObj = new Object();
                        // regObj.Name = "Select an Option";
                        // regObj.TicketPriceID = "$0";
                        // regObj.Currency = "USD";
                        // regObj.TicketPrice = "$0";

                        // var arr = [];
                        // arr.push({
                        //     Name: "Select an Option",
                        //     TicketPriceID: "$0",
                        //     Currency: "USD",
                        //     TicketPrice: "$0"

                        // });

                        jsonObj.RegistrationType.RegTypes = field.RegTypes ? field.RegTypes : []; // JSON.stringify(arr); // "[{Name: Select an Option,TicketPriceID: $0,Currency: USD, TicketPrice:$0}]";
                        //------------------------------------------------------------
                        debugger;
                        jsonObj.MailingAddress = {};
                        jsonObj.MailingAddress.IsShowMailingAddress = field.showMailingAddress;
                        jsonObj.MailingAddress.IsMailingAddressMandatory = field.IsMailingAddressMandatory;
                        jsonObj.MailingAddress.MailingAddressLabel = field.MailingAddressLabel;
                        //------------------------------------------------------------
                        jsonObj.City = {};
                        jsonObj.City.IsShowCity = field.showCity;
                        jsonObj.City.IsCityMandatory = field.IsCityMandatory;
                        jsonObj.City.CityDisplayLabel = field.CityLabel;
                        //------------------------------------------------------------
                        jsonObj.Zip = {};
                        jsonObj.Zip.IsShowZip = field.showZip;
                        jsonObj.Zip.IsZipMandatory = field.IsZipMandatory;
                        jsonObj.Zip.ZipDisplayLabel = field.ZipLabel;
                        //------------------------------------------------------------
                        jsonObj.Country = {};
                        jsonObj.Country.IsShowCountryList = field.showCountry;
                        jsonObj.Country.countryList = field.countryList;
                        jsonObj.Country.IsCountryMandatory = field.IsCountryMandatory;
                        jsonObj.Country.CountryDisplayLabel = field.CountryLabel;
                        //------------------------------------------------------------
                        debugger;
                        jsonObj.State = {};
                        jsonObj.State.IsShowStateList = field.showState;
                        jsonObj.State.IsStateMandatory = field.IsStateMandatory;
                        jsonObj.State.USAStateList = field.USAStateList;
                        jsonObj.State.UKStateList = field.UKStateList;
                        jsonObj.State.IndiaStateList = field.IndiaStateList;
                        jsonObj.State.SingaporeStateList = field.SingaporeStateList;
                        jsonObj.State.UAEStates = field.UAEStates;
                        jsonObj.State.StateDisplayLabel = field.StateLabel;
                        jsonObj.State.OtherStateDisplayLabel = field.OtherStateDisplayLabel;
                        jsonObj.State.IsShowOtherStateTextBox = field.IsShowOtherStateTextBox;
                        jsonObj.State.IsEnabledState = field.IsEnabledState;
                        //------------------------------------------------------------

                        jsonObj.SubmitButtonDisplayLabel = field.SubmitButtonDisplaylabel;
                        jsonObj.FormType = field.FormType;
                        jsonObj.FormName = field.FormName;
                        jsonObj.LandingPageShowEventListLink = field.LandingPageShowEventListLink;
                        jsonObj.LandingPageShowHostedByPanel = field.LandingPageShowHostedByPanel;
                        //jsonObj.LivePublishableKey = field.LivePublishableKey;
                        //jsonObj.TestPublishableKey = field.TestPublishableKey;
                        jsonObj.Payingto = field.PayingTo;
                        jsonObj.PayingToLogo = field.PayingToLogo;




                        //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

                        // console.log(this.fields);
                        // console.log(this.fieldData);
                        var docRef = con.eventDB
                            .collection(cn)
                            .doc("FormList")
                            .collection("RegistrationForms")
                            .doc(`${field.FormId}`);
                        docRef
                            .get()
                            .then(function (doc) {
                                if (doc.exists) {
                                    debugger;
                                    var docObj = new Object();
                                    //docObj.FormId = field.FormName;
                                    docObj.FormType = field.FormType;
                                    // docObj.MapTo = vm.MapTo;
                                    docObj.FormTitle = field.FormName;
                                    // docObj.FormJson = vm.fields;
                                    // docObj.SubmitButtonText = vm.SubmitButtonText;
                                    //docObj.AllowMultipleSubmission = vm.AllowMultipleSubmission;
                                    //docObj.AllowEditAfterSubmission = vm.AllowEditAfterSubmission;
                                    //docObj.CreatedDate = new Date();
                                    docObj.LastModifiedDate = new Date();
                                    docObj.BasicForm = jsonObj;
                                    //--------------------- Dynamic Fields For DB saving ----------------------------------------------------
                                    docObj.DynamicFieldsJson = field.DynamicFieldsJson;
                                    //------------------------------------------------------------------------
                                    //---------------------- PRE SIGN UP For DB saving only--------------------------------------

                                    debugger;
                                    var jsonPreSignupObjDB = new Object();
                                    //  jsonPreSignupObjDB.PreSignupTerms = {};
                                    jsonPreSignupObjDB.HTMLbody = field.PreSignupTermsHtml;
                                    jsonPreSignupObjDB.RequireAcceptance = field.RequireAcceptance;
                                    jsonPreSignupObjDB.AcceptanceValidationDisplayLabel = field.AcceptanceValidationDisplayLabel;
                                    jsonPreSignupObjDB.AcceptanceDisplayText = field.AcceptanceDisplayText;
                                    jsonPreSignupObjDB.OptInOne = field.OptInOne;
                                    jsonPreSignupObjDB.OptInOneIsRequired = field.OptInOneIsRequired;
                                    jsonPreSignupObjDB.OptInTwo = field.OptInTwo;
                                    jsonPreSignupObjDB.OptInTwoIsRequired = field.OptInTwoIsRequired;


                                    docObj.PreSignupTerms = jsonPreSignupObjDB;
                                    //---------------------------------------------------------------------------------






                                    debugger;
                                    var ref = con.eventDB
                                        .collection(cn)
                                        .doc("FormList")
                                        .collection("RegistrationForms")
                                        .doc(`${field.FormId}`)
                                        .update(docObj)
                                        .then(function (RFDoc) {
                                            console.log("sucess");
                                            // dynamic FormId update
                                            //let path = cn + '/Registration/DefaultRegFormSettings.json';
                                            let path = cn + '/Registration/';
                                            let json = JSON.stringify(jsonObj, null, 2);
                                            const blob = new Blob([json], { type: "application/json" });
                                            storageRef.child(path + "DefaultRegFormSettings.JSON").put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                                                debugger;
                                                resolve({ "status": 200, "message": "JSON updated" })
                                            })

                                            //++++++++++++++++++++++++++++++++++++++++++++ PRE SIGN UP ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

                                            storageRef.child(pathPreSignUp).getDownloadURL().then(function (url2) {


                                                axios.get(url2.toString()).then(result2 => {
                                                    if (typeof result2.data == 'string')
                                                        jsonPreSignupObj = eval('(' + result2.data + ')');
                                                    else if (typeof result2.data == 'object')
                                                        jsonPreSignupObj = result2.data
                                                    else
                                                        jsonPreSignupObj = null
                                                    if (jsonPreSignupObj) {

                                                        debugger;
                                                        jsonPreSignupObj.PreSignupTerms = {};
                                                        jsonPreSignupObj.PreSignupTerms.HTMLbody = field.PreSignupTermsHtml;
                                                        jsonPreSignupObj.PreSignupTerms.RequireAcceptance = field.RequireAcceptance;
                                                        jsonPreSignupObj.PreSignupTerms.AcceptanceValidationDisplayLabel = field.AcceptanceValidationDisplayLabel;
                                                        jsonPreSignupObj.PreSignupTerms.AcceptanceDisplayText = field.AcceptanceDisplayText;
                                                        jsonPreSignupObj.PreSignupTerms.OptInOne = field.OptInOne;
                                                        jsonPreSignupObj.PreSignupTerms.OptInOneIsRequired = field.OptInOneIsRequired;
                                                        jsonPreSignupObj.PreSignupTerms.OptInTwo = field.OptInTwo;
                                                        jsonPreSignupObj.PreSignupTerms.OptInTwoIsRequired = field.OptInTwoIsRequired;


                                                        let path = cn + '/Registration/';
                                                        let json2 = JSON.stringify(jsonPreSignupObj, null, 2);
                                                        const blob = new Blob([json2], { type: "application/json" });
                                                        storageRef.child(path + "PreSignupTerms.json").put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                                                            debugger;
                                                            resolve({ "status": 200, "message": "Pre sign up JSON updated" })
                                                        })
                                                    }

                                                }).catch(function (error) {
                                                    console.error("Error creating PRE SIGN UP Form in storage: ", error);
                                                });


                                            }).catch(function (error) {
                                                console.log("Error getting file from OU_UAT for PRE SIGN UP :", error);
                                            });
                                            //++++++++++++++++++++++++++++++++++ PRE SIGN UP ENDS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++




                                            debugger;
                                            //++++++++++++++++++++++++++++++++++++++++++++  Dynamic Form Builder Storage save start ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

                                            storageRef.child(pathDynamicForm).getDownloadURL().then(function (url3) {


                                                axios.get(url3.toString()).then(result3 => {
                                                    if (typeof result3.data == 'string')
                                                        jsonDynamicForm = eval('(' + result3.data + ')');
                                                    else if (typeof result3.data == 'object')
                                                        jsonDynamicForm = result3.data
                                                    else
                                                        jsonDynamicForm = null
                                                    if (jsonDynamicForm) {

                                                        debugger;
                                                        jsonDynamicForm = field.DynamicFieldsJson

                                                        debugger;
                                                        let path = cn + '/Registration/';
                                                        let json3 = JSON.stringify(jsonDynamicForm, null, 2);
                                                        const blob = new Blob([json3], { type: "application/json" });
                                                        storageRef.child(path + "FormBuilderReg.json").put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                                                            debugger;
                                                            resolve({ "status": 200, "message": "Dynamic Form JSON updated" })
                                                        })
                                                    }

                                                }).catch(function (error) {
                                                    console.error("Error creating Dynamic Form  in storage: ", error);
                                                });


                                            }).catch(function (error) {
                                                console.log("Error getting file from OU_UAT for Dynamic Form :", error);
                                            });


                                            //++++++++++++++++++++++++++++++++++  Dynamic Form Builder Storage save  ENDS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++







                                            //------------------------ Update LOGO ----------------------------------------------

                                            // if (field.RegLogoImgFile) {
                                            //     let file = field.RegLogoImgFile
                                            //     let metadata = {
                                            //         'contentType': file.type
                                            //     }
                                            //     debugger;
                                            //     storageRef.child(cn + '/Registration/LogoImage/' + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function(snapshot) {
                                            //         snapshot.ref.getDownloadURL().then(function(url) {
                                            //             debugger;
                                            //             console.log(url);
                                            //             // Regref.doc(field.FormName).update({ PayingToLogo: url.toString() }).then(function(doc) {
                                            //             //     field.RegLogoImgFile = url.toString()
                                            //             //         //context.dispatch('updateRoundtable', field);
                                            //             //     resolve({ status: 200, message: 'Data & File Updated.' })
                                            //             // }).catch(function(error) {
                                            //             //     //console.log('data update '+error)                
                                            //             // })



                                            //         }).catch(function(error) {
                                            //             //console.log('download url '+error)                
                                            //         })
                                            //     }).catch(function(error) {
                                            //         //console.log('imgae upload '+error)                
                                            //     })
                                            // } else {

                                            //     // context.dispatch('updateRoundtable', field);
                                            //     resolve({ status: 200, message: 'Data Updated.' })
                                            // }
                                            //------------------------------------------------------------------------------------


                                        })
                                        .catch(function (error) {
                                            console.error("Error creating registration Form: ", error);
                                        });
                                }
                                else {
                                    resolve({ status: 500, "message": "Something went wrong!" })
                                }

                            })
                            .catch(function (error) {
                                console.log("Error saving Form:", error);
                            });

                        //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++




                    }
                })
            }).catch((err) => {
                // Didn't exist... or some other error
                //console.log(err)
                resolve(null)
            })
        })
    },
    SaveRegistrationForm(context, field) {

        //  let path = cn + '/Registration/DefaultRegFormSettings.json';
        let path = ClientCollectionName + '/Defaults/DefaultRegFormSettings.JSON';
        let pathPreSignUp = ClientCollectionName + '/Defaults/PreSignupTerms.json';
        let pathDynamicForm = ClientCollectionName + '/Defaults/PreSignupTerms.json';
        debugger;
        return new Promise((resolve, reject) => {
            storageRef.child(path).getDownloadURL().then(function (url) {
                axios.get(url.toString()).then(result => {
                    let jsonObj = null
                    let jsonPreSignupObj = null
                    let jsonDynamicForm = null
                    debugger;
                    if (typeof result.data == 'string')
                        jsonObj = eval('(' + result.data + ')');
                    else if (typeof result.data == 'object')
                        jsonObj = result.data
                    else
                        jsonObj = null
                    if (jsonObj) {
                        //------------- Basic form --------------------------------
                        //debugger;
                        debugger;
                        console.log(JSON.stringify(field));
                        jsonObj.Salutation = {};
                        jsonObj.Salutation.IsSalutationMandatory = field.IsSalutationMandatory;
                        jsonObj.Salutation.showSalutation = field.showSalutation;
                        jsonObj.Salutation.salutationDisplayLabel = field.salutationLabel;
                        //----------------------------------------------------------------
                        jsonObj.FirstName = {};
                        jsonObj.FirstName.firstNameDisplayLabel = field.FirstNameLabel;
                        jsonObj.FirstName.IsShowfName = field.showFirstName;
                        jsonObj.FirstName.IsfNameMandatory = field.IsFirstNameMandatory;
                        //------------------------------------------------------------
                        jsonObj.LastName = {};
                        jsonObj.LastName.lastNameDisplayLabel = field.LastNameLabel;
                        jsonObj.LastName.IsShowlName = field.showLastName;
                        jsonObj.LastName.IslNameMandatory = field.IsLastNameMandatory;
                        //------------------------------------------------------------
                        jsonObj.ProfilePicture = {};
                        jsonObj.ProfilePicture.ProfilePictureDisplayLabel = field.ProfilePictureLabel;
                        jsonObj.ProfilePicture.IsProfilePictureMandatory = field.IsProfilePictureMandatory;
                        jsonObj.ProfilePicture.IsShowProfilePicture = field.showProfilePicture;
                        // //------------------------------------------------------------
                        jsonObj.Email = {};
                        jsonObj.Email.IsShowEmail = field.showEmail;
                        jsonObj.Email.IsEmailMandatory = field.IsEmailMandatory;
                        jsonObj.Email.emailDisplayLabel = field.EmailLabel;
                        //------------------------------------------------------------

                        jsonObj.Company = {};
                        jsonObj.Company.IsShowCompany = field.showCompany;
                        jsonObj.Company.IsCompanyMandatory = field.IsCompanyMandatory;
                        jsonObj.Company.companyDisplayLabel = field.CompanyLabel;
                        //------------------------------------------------------------
                        jsonObj.Title = {};
                        jsonObj.Title.IsShowTitle = field.showTitle;
                        jsonObj.Title.IsTitleMandatory = field.IsTitleMandatory;
                        jsonObj.Title.TitleDisplayLabel = field.TitleLabel;
                        //------------------------------------------------------------
                        jsonObj.Mobile = {};
                        jsonObj.Mobile.IsShowMobile = field.showMobile;
                        jsonObj.Mobile.IsMobileMandatory = field.IsMobileMandatory;
                        jsonObj.Mobile.mobileDisplayLabel = field.MobileLabel;
                        //------------------------------------------------------------
                        jsonObj.Tags = {};
                        jsonObj.Tags.IsShowTags = field.showTags;
                        jsonObj.Tags.IsTagsMandatory = field.IsTagsMandatory;
                        jsonObj.Tags.tagsDisplayLabel = field.TagsLabel;
                        //------------------------------------------------------------
                        debugger;
                        jsonObj.RegistrationType = {};
                        jsonObj.RegistrationType.IsShowRegFormType = field.IsShowRegFormType;
                        jsonObj.RegistrationType.IsRegistrantTypesMandatory = field.IsRegistrantTypesMandatory;
                        jsonObj.RegistrationType.RegTypeDisplayLabel = field.RegTypeDisplayLabel;

                        // var regObj = new Object();
                        // regObj.Name = "Select an Option";
                        // regObj.TicketPriceID = "$0";
                        // regObj.Currency = "USD";
                        // regObj.TicketPrice = "$0";

                        // var arr = [];
                        // arr.push({
                        //     Name: "Select an Option",
                        //     TicketPriceID: "$0",
                        //     Currency: "USD",
                        //     TicketPrice: "$0"

                        // });

                        jsonObj.RegistrationType.RegTypes = []; // JSON.stringify(arr); // "[{Name: Select an Option,TicketPriceID: $0,Currency: USD, TicketPrice:$0}]";
                        //------------------------------------------------------------
                        debugger;
                        jsonObj.MailingAddress = {};
                        jsonObj.MailingAddress.IsShowMailingAddress = field.showMailingAddress;
                        jsonObj.MailingAddress.IsMailingAddressMandatory = field.IsMailingAddressMandatory;
                        jsonObj.MailingAddress.MailingAddressLabel = field.MailingAddressLabel;
                        //------------------------------------------------------------
                        jsonObj.City = {};
                        jsonObj.City.IsShowCity = field.showCity;
                        jsonObj.City.IsCityMandatory = field.IsCityMandatory;
                        jsonObj.City.CityDisplayLabel = field.CityLabel;
                        //------------------------------------------------------------
                        jsonObj.Zip = {};
                        jsonObj.Zip.IsShowZip = field.showZip;
                        jsonObj.Zip.IsZipMandatory = field.IsZipMandatory;
                        jsonObj.Zip.ZipDisplayLabel = field.ZipLabel;
                        //------------------------------------------------------------
                        jsonObj.Country = {};
                        jsonObj.Country.IsShowCountryList = field.showCountry;
                        jsonObj.Country.countryList = field.countryList;
                        jsonObj.Country.IsCountryMandatory = field.IsCountryMandatory;
                        jsonObj.Country.CountryDisplayLabel = field.CountryLabel;
                        //------------------------------------------------------------
                        debugger;
                        jsonObj.State = {};
                        jsonObj.State.IsShowStateList = field.showState;
                        jsonObj.State.IsStateMandatory = field.IsStateMandatory;
                        jsonObj.State.USAStateList = field.USAStateList;
                        jsonObj.State.UKStateList = field.UKStateList;
                        jsonObj.State.IndiaStateList = field.IndiaStateList;
                        jsonObj.State.SingaporeStateList = field.SingaporeStateList;
                        jsonObj.State.UAEStates = field.UAEStates;
                        jsonObj.State.StateDisplayLabel = field.StateLabel;
                        jsonObj.State.OtherStateDisplayLabel = field.OtherStateDisplayLabel;
                        jsonObj.State.IsShowOtherStateTextBox = field.IsShowOtherStateTextBox;
                        jsonObj.State.IsEnabledState = field.IsEnabledState;
                        //------------------------------------------------------------

                        jsonObj.SubmitButtonDisplayLabel = field.SubmitButtonDisplaylabel;
                        jsonObj.FormType = field.FormType;
                        jsonObj.FormName = field.FormName;
                        jsonObj.LandingPageShowEventListLink = field.LandingPageShowEventListLink;
                        jsonObj.LandingPageShowHostedByPanel = field.LandingPageShowHostedByPanel;
                        //jsonObj.LivePublishableKey = field.LivePublishableKey;
                        //jsonObj.TestPublishableKey = field.TestPublishableKey;
                        jsonObj.Payingto = field.PayingTo;
                        jsonObj.PayingToLogo = field.PayingToLogo;




                        //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

                        // console.log(this.fields);
                        // console.log(this.fieldData);
                        var docRef = con.eventDB
                            .collection(cn)
                            .doc("FormList")
                            .collection("RegistrationForms")
                            .doc(field.FormName);
                        docRef
                            .get()
                            .then(function (doc) {
                                if (!doc.exists) {
                                    debugger;
                                    var docObj = new Object();
                                    docObj.FormId = field.FormName;
                                    docObj.FormType = field.FormType;
                                    // docObj.MapTo = vm.MapTo;
                                    docObj.FormTitle = field.FormName;
                                    // docObj.FormJson = vm.fields;
                                    // docObj.SubmitButtonText = vm.SubmitButtonText;
                                    //docObj.AllowMultipleSubmission = vm.AllowMultipleSubmission;
                                    //docObj.AllowEditAfterSubmission = vm.AllowEditAfterSubmission;
                                    docObj.CreatedDate = new Date();
                                    docObj.LastModifiedDate = new Date();
                                    docObj.BasicForm = jsonObj;
                                    //--------------------- Dynamic Fields For DB saving ----------------------------------------------------
                                    docObj.DynamicFieldsJson = field.DynamicFieldsJson;
                                    //------------------------------------------------------------------------
                                    //---------------------- PRE SIGN UP For DB saving only--------------------------------------

                                    debugger;
                                    var jsonPreSignupObjDB = new Object();
                                    //  jsonPreSignupObjDB.PreSignupTerms = {};
                                    jsonPreSignupObjDB.HTMLbody = field.PreSignupTermsHtml;
                                    jsonPreSignupObjDB.RequireAcceptance = field.RequireAcceptance;
                                    jsonPreSignupObjDB.AcceptanceValidationDisplayLabel = field.AcceptanceValidationDisplayLabel;
                                    jsonPreSignupObjDB.AcceptanceDisplayText = field.AcceptanceDisplayText;
                                    jsonPreSignupObjDB.OptInOne = field.OptInOne;
                                    jsonPreSignupObjDB.OptInOneIsRequired = field.OptInOneIsRequired;
                                    jsonPreSignupObjDB.OptInTwo = field.OptInTwo;
                                    jsonPreSignupObjDB.OptInTwoIsRequired = field.OptInTwoIsRequired;


                                    docObj.PreSignupTerms = jsonPreSignupObjDB;
                                    //---------------------------------------------------------------------------------






                                    debugger;
                                    var ref = con.eventDB
                                        .collection(cn)
                                        .doc("FormList")
                                        .collection("RegistrationForms")
                                        .add(docObj)
                                        .then(function (RFDoc) {
                                            console.log("sucess");
                                            // dynamic FormId update
                                            Regref.doc(`${RFDoc.id}`).update({ FormId: `${RFDoc.id}` })
                                            //let path = cn + '/Registration/DefaultRegFormSettings.json';
                                            let path = cn + '/Registration/';
                                            let json = JSON.stringify(jsonObj, null, 2);
                                            const blob = new Blob([json], { type: "application/json" });
                                            storageRef.child(path + "DefaultRegFormSettings.JSON").put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                                                debugger;
                                                resolve("JSON updated")
                                            })

                                            //++++++++++++++++++++++++++++++++++++++++++++ PRE SIGN UP ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

                                            storageRef.child(pathPreSignUp).getDownloadURL().then(function (url2) {


                                                axios.get(url2.toString()).then(result2 => {
                                                    if (typeof result2.data == 'string')
                                                        jsonPreSignupObj = eval('(' + result2.data + ')');
                                                    else if (typeof result2.data == 'object')
                                                        jsonPreSignupObj = result2.data
                                                    else
                                                        jsonPreSignupObj = null
                                                    if (jsonPreSignupObj) {

                                                        debugger;
                                                        jsonPreSignupObj.PreSignupTerms = {};
                                                        jsonPreSignupObj.PreSignupTerms.HTMLbody = field.PreSignupTermsHtml;
                                                        jsonPreSignupObj.PreSignupTerms.RequireAcceptance = field.RequireAcceptance;
                                                        jsonPreSignupObj.PreSignupTerms.AcceptanceValidationDisplayLabel = field.AcceptanceValidationDisplayLabel;
                                                        jsonPreSignupObj.PreSignupTerms.AcceptanceDisplayText = field.AcceptanceDisplayText;
                                                        jsonPreSignupObj.PreSignupTerms.OptInOne = field.OptInOne;
                                                        jsonPreSignupObj.PreSignupTerms.OptInOneIsRequired = field.OptInOneIsRequired;
                                                        jsonPreSignupObj.PreSignupTerms.OptInTwo = field.OptInTwo;
                                                        jsonPreSignupObj.PreSignupTerms.OptInTwoIsRequired = field.OptInTwoIsRequired;


                                                        let path = cn + '/Registration/';
                                                        let json2 = JSON.stringify(jsonPreSignupObj, null, 2);
                                                        const blob = new Blob([json2], { type: "application/json" });
                                                        storageRef.child(path + "PreSignupTerms.json").put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                                                            debugger;
                                                            resolve("Pre sign up JSON updated")
                                                        })
                                                    }

                                                }).catch(function (error) {
                                                    console.error("Error creating PRE SIGN UP Form in storage: ", error);
                                                });


                                            }).catch(function (error) {
                                                console.log("Error getting file from OU_UAT for PRE SIGN UP :", error);
                                            });
                                            //++++++++++++++++++++++++++++++++++ PRE SIGN UP ENDS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++




                                            debugger;
                                            //++++++++++++++++++++++++++++++++++++++++++++  Dynamic Form Builder Storage save start ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

                                            storageRef.child(pathDynamicForm).getDownloadURL().then(function (url3) {


                                                axios.get(url3.toString()).then(result3 => {
                                                    if (typeof result3.data == 'string')
                                                        jsonDynamicForm = eval('(' + result3.data + ')');
                                                    else if (typeof result3.data == 'object')
                                                        jsonDynamicForm = result3.data
                                                    else
                                                        jsonDynamicForm = null
                                                    if (jsonDynamicForm) {

                                                        debugger;
                                                        jsonDynamicForm = field.DynamicFieldsJson

                                                        debugger;
                                                        let path = cn + '/Registration/';
                                                        let json3 = JSON.stringify(jsonDynamicForm, null, 2);
                                                        const blob = new Blob([json3], { type: "application/json" });
                                                        storageRef.child(path + "FormBuilderReg.json").put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                                                            debugger;
                                                            resolve("Dynamic Form JSON updated")
                                                        })
                                                    }

                                                }).catch(function (error) {
                                                    console.error("Error creating Dynamic Form  in storage: ", error);
                                                });


                                            }).catch(function (error) {
                                                console.log("Error getting file from OU_UAT for Dynamic Form :", error);
                                            });


                                            //++++++++++++++++++++++++++++++++++  Dynamic Form Builder Storage save  ENDS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++







                                            //------------------------ Update LOGO ----------------------------------------------

                                            // if (field.RegLogoImgFile) {
                                            //     let file = field.RegLogoImgFile
                                            //     let metadata = {
                                            //         'contentType': file.type
                                            //     }
                                            //     debugger;
                                            //     storageRef.child(cn + '/Registration/LogoImage/' + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function(snapshot) {
                                            //         snapshot.ref.getDownloadURL().then(function(url) {
                                            //             debugger;
                                            //             console.log(url);
                                            //             // Regref.doc(field.FormName).update({ PayingToLogo: url.toString() }).then(function(doc) {
                                            //             //     field.RegLogoImgFile = url.toString()
                                            //             //         //context.dispatch('updateRoundtable', field);
                                            //             //     resolve({ status: 200, message: 'Data & File Updated.' })
                                            //             // }).catch(function(error) {
                                            //             //     //console.log('data update '+error)                
                                            //             // })



                                            //         }).catch(function(error) {
                                            //             //console.log('download url '+error)                
                                            //         })
                                            //     }).catch(function(error) {
                                            //         //console.log('imgae upload '+error)                
                                            //     })
                                            // } else {

                                            //     // context.dispatch('updateRoundtable', field);
                                            //     resolve({ status: 200, message: 'Data Updated.' })
                                            // }
                                            //------------------------------------------------------------------------------------


                                        })
                                        .catch(function (error) {
                                            console.error("Error creating registration Form: ", error);
                                        });
                                }

                            })
                            .catch(function (error) {
                                console.log("Error saving Form:", error);
                            });

                        //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++




                    }
                })
            }).catch((err) => {
                // Didn't exist... or some other error
                //console.log(err)
                resolve(null)
            })
        })
    },
    searchAttendeesApi(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": Session_Event_Id,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    "search": [
                        {
                            "key": "FirstName",
                            "operator": "LIKE",
                            "value": `${field.value}`
                        },
                        {
                            "key": "LastName",
                            "operator": "LIKE",
                            "value": `${field.value}`
                        },
                        {
                            "key": "Name",
                            "operator": "LIKE",
                            "value": `${field.value}`
                        },
                        {
                            "key": "Email",
                            "operator": "LIKE",
                            "value": `${field.value}`
                        }
                    ],
                    "filter": []
                }
            }

            axios.post(SearchAttendees, requestData, { headers: headers }).then(response => {
                if (response.data.status == 0)
                    resolve({ status: 200, data: response.data.result });
                else
                    resolve({ status: 500, data: [] });
            }).catch(err => { reject(err) });
        })
    },
    fetchAttendees({ commit }) {
        Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
        attendeeRef = con.eventDB.collection(cn).doc("AttendeeList").collection("Attendees");
        return new Promise((resolve, reject) => {
            let markers = []
            attendeeRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    let docObj = doc.data();
                    docObj.HideInList = docObj.HideInList ? docObj.HideInList : false;
                    if (doc.data().ShowInCMSAttendeeList == undefined) {
                        markers.push(docObj)
                    } else if (doc.data().ShowInCMSAttendeeList == 1) {
                        markers.push(docObj)
                    }
                })
                commit('SET_ATTENDEES', markers)
                resolve(markers)
            }).catch(function (error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    fetchHideInLeaderboardAttendees({ commit }) {
        Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
        attendeeRef = con.eventDB.collection(cn).doc("AttendeeList").collection("Attendees");
        return new Promise((resolve, reject) => {
            let markers = []
            attendeeRef.where('HideInLeaderboard', '==', true).get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    let docObj = doc.data();
                    if (doc.data().ShowInCMSAttendeeList == undefined) {
                        markers.push(docObj)
                    } else if (doc.data().ShowInCMSAttendeeList == 1) {
                        markers.push(docObj)
                    }
                })
                resolve(markers)
            }).catch(function (error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    /*fetchRegistrationTicketTypes({ commit }) {
        return new Promise((resolve, reject) => {
            let markers = []
            regTicketTypes.get().then(querySnapshot => {
                let totallength = querySnapshot.docs.length;
                let count = 0;
                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                    count++;
                })
                if (count == totallength)
                    resolve(markers)
            }).catch(function (error) {
                console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },*/
    /*editRegistrationTicketType(context, field) {
        return new Promise((resolve, reject) => {
            regTicketTypes.doc(`${field.RegistrationTypeId}`).update({
                RegistrationType: field.data.RegistrationType,
                ColorCode: field.data.ColorCode
            }).then(function () {
                resolve({ status: 200, message: "Data Updated." })
            }).catch(err => {
                resolve({ status: 500, message: "Data not Updated!" })
            })
        })
    },*/
    /*addRegistrationTicketType(context, field) {
        return new Promise((resolve, reject) => {
            regTicketTypes.add({
                RegistrationTypeId: null,
                RegistrationType: field.data.RegistrationType,
                ColorCode: field.data.ColorCode
            }).then(function (docRef) {
                regTicketTypes.doc(`${docRef.id}`).update({
                    RegistrationTypeId: docRef.id
                }).then(function () {
                    resolve({ status: 200, message: "Data Added.", RegistrationTypeId: docRef.id })
                })
            }).catch(err => {
                resolve({ status: 500, message: "Data not Added!", RegistrationTypeId: null })
            })
        })
    },*/
    fetchAttendeesMapping({ commit }) {
        Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
        attendeeRef = con.eventDB.collection(cn).doc("AttendeeList").collection("Attendees");
        return new Promise((resolve, reject) => {
            let markers = []
            let count = 0
            let totallength = 0;
            attendeeRef.get().then(querySnapshot => {
                totallength = querySnapshot.docs.length
                querySnapshot.docs.forEach(doc => {
                    var docObj = doc.data()
                    attendeeRef.doc(`${doc.id}`).collection('MappedSessions').get().then(function (sessions) {
                        docObj.NumberofSessions = sessions.docs.length
                        markers.push(docObj)
                        count++;
                        if (count == totallength) {
                            commit('SET_ATTENDEESMAPPING', markers)
                            resolve(markers)
                        }
                    })
                })
            }).catch(function (error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    fetchAttendeesPaidReg({ commit }) {
        debugger;
        Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
        attendeeRef = con.eventDB.collection(cn).doc("AttendeeList").collection("Attendees").where("FormType", "==", "PAID");
        return new Promise((resolve, reject) => {
            let markers = []
            attendeeRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                commit('SET_ATTENDEES', markers)
                resolve(markers)
            }).catch(function (error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    fetchAttendee(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        Name: '',
                        FirstName: '',
                        LastName: '',
                        Email: '',
                        //Password: randomNumber,
                        Tags: '',
                        Phone: '',
                        PhoneCountryCode: 'IN',
                        Country: '',
                        FormType: 'FREE',
                        RegistrationType: {
                            ColorCode: "",
                            RegistrationType: "Attendee",
                            RegistrationTypeId: null
                        },
                        Company: '',
                        Designation: '',
                        Profile: '',
                        ProfilePictureURL: '',
                        Website: '',
                        SocialLinks: [],
                        MappedLocations: [],
                        CheckinRoles: [],
                    }
                })
            } else {
                let docObj = new Object
                attendeeRef.doc(`${id}`).get().then(function (doc) {
                    docObj = doc.data()
                    docObj.FormType = doc.data().FormType ? doc.data().FormType : 'FREE'
                    docObj.RegistrationType = doc.data().RegistrationType ? doc.data().RegistrationType : { ColorCode: "", RegistrationType: "Attendee", RegistrationTypeId: null }
                    //onsole.log(id)
                    //if(doc.data().SocialLinks) {

                    docObj.SocialLinks = {
                        /*Facebook: doc.data().SocialLinks[0].Facebook,
                        GooglePlus: doc.data().SocialLinks[1].GooglePlus,
                        LinkedIn: doc.data().SocialLinks[2].LinkedIn,
                        Twitter: doc.data().SocialLinks[3].Twitter  */
                    }

                    if (doc.data().SocialLinks) {
                        for (let i = 0; i < doc.data().SocialLinks.length; i++) {
                            let socialkeys = Object.keys(doc.data().SocialLinks[i])
                            let socialvaues = Object.values(doc.data().SocialLinks[i])
                            if (socialkeys[0] && socialvaues[0])
                                docObj.SocialLinks[socialkeys[0]] = socialvaues[0]
                        }
                    }
                    if (!docObj.MappedLocations) {
                        docObj.MappedLocations = [];
                    }
                    if (!docObj.CheckinRoles) {
                        docObj.CheckinRoles = [];
                    }
                    resolve({ status: 200, data: docObj });
                }).catch(function (error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }

        })
    },
    updateAttendee(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": Session_Event_Id,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    UserId: `${field.id}`,
                    Name: field.data.FirstName.trim() + ' ' + field.data.LastName.trim(),
                    FirstName: field.data.FirstName.trim(),
                    LastName: field.data.LastName.trim(),
                    Phone: field.data.Phone,
                    PhoneCountryCode: field.data.PhoneCountryCode ? field.data.PhoneCountryCode : '',
                    Country: field.data.Country ? field.data.Country : '',
                    FormType: field.data.FormType ? field.data.FormType : 'FREE',
                    RegistrationType: field.data.RegistrationType ? field.data.RegistrationType : { ColorCode: "", RegistrationType: "Attendee", RegistrationTypeId: null },
                    Company: field.data.Company,
                    Designation: field.data.Designation,
                    Profile: field.data.Profile,
                    Tags: (field.data.Tags ? field.data.Tags : ''),
                    Website: field.data.Website,
                    MappedLocations: field.data.MappedLocations ? field.data.MappedLocations : [],
                    CheckinRoles: field.data.CheckinRoles ? field.data.CheckinRoles : [],
                    Username: field.data.Username ? field.data.Username : "",
                    DomainArea: field.data.DomainArea ? field.data.DomainArea : "",
                    BaseLab: field.data.BaseLab ? field.data.BaseLab : "",
                    CheckinPrimaryRole: field.data.DefaultCheckinRole ? field.data.DefaultCheckinRole : "",
                    AllowRemoteCheckin: field.data.AllowRemoteCheckin,
                    DesignationId: field.data.DesignationId ? field.data.DesignationId : "",
                    
                    //LastModifiedDate: new Date()
                }
            }


            context.dispatch('uploadProfileImage', { path: cn + '/Attendee/profileImage/', file: field.data.file, ProfilePictureURL: field.data.ProfilePictureURL }).then(ProfilePictureURL => {
                if (ProfilePictureURL) {
                    requestData.data.ProfilePictureURL = ProfilePictureURL;
                }
                axios.post(UpdateUserAPI, requestData, { headers: headers }).then(response => {
                    if (response.data.status == 0)
                        resolve({ status: 200, message: "Attendee updated" })
                    else
                        resolve({ status: 500, message: "Attendee not updated" })
                }).catch(function (error) {
                    reject(error)
                })
            })
        })
    },
    uploadImage(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.path) {
                let path = field.path;
                let file = field.file
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(path + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        resolve(url.toString())
                    })
                })
            } else {
                resolve(null)
            }
        })
    },
    uploadProfileImage(context, field) {
        return new Promise((resolve, reject) => {
            if (field.path && field.file) {
                let path = field.path;
                const file = field.file

                storageRef.child(path + (new Date().getTime()) + "_" + file.name).putString(field.ProfilePictureURL, 'data_url').then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        resolve(url.toString())
                    })
                })
            } else {
                resolve(null)
            }

        })
    },
    updateAttendeeSocialDetail(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": Session_Event_Id,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    "UserId": `${field.id}`,
                    "SocialLinks": [
                        { Facebook: (field.data.SocialLinks.Facebook ? field.data.SocialLinks.Facebook : '') },
                        { GooglePlus: (field.data.SocialLinks.GooglePlus ? field.data.SocialLinks.GooglePlus : '') },
                        { LinkedIn: (field.data.SocialLinks.LinkedIn ? field.data.SocialLinks.LinkedIn : '') },
                        { Twitter: (field.data.SocialLinks.Twitter ? field.data.SocialLinks.Twitter : '') }
                    ]
                }
            }
            axios.post(UpdateUserAPI, requestData, { headers: headers }).then(response => {
                if (response.data.status == 0)
                    resolve({ status: 200, message: "Social detail updated" })
                else
                    resolve({ status: 500, message: "Social detail not updated" })
            }).catch(err => {
                reject(err)
            })
        })
    },
    addAttendee(context, field) {
        return new Promise((resolve, reject) => {
            if (field.data.Email == '') {
                resolve({ status: 500, message: 'Enter proper email!.' })
            } else {
                attendeeRef.where("Email", "==", field.data.Email.toLowerCase().trim()).get().then(function (snapShot) {
                    let doc = snapShot.docs[0];
                    if (snapShot.empty) {
                        var profileUrl = "";
                        if (field.data.file != null || field.data.file != undefined) {
                            const file = field.data.file
                            let metadata = {
                                'contentType': file.type
                            }
                            storageRef.child(cn + '/Attendee/profileImage/' + (new Date().getTime()) + "_" + file.name).putString(field.data.ProfilePictureURL, 'data_url').then(function (snapshot) {
                                snapshot.ref.getDownloadURL().then(function (url) {
                                    profileUrl = url.toString();
                                    let docObj = {
                                        Name: field.data.FirstName.trim() + ' ' + field.data.LastName.trim(),
                                        FirstName: field.data.FirstName.trim(),
                                        LastName: field.data.LastName.trim(),
                                        Email: field.data.Email.toLowerCase().trim(),
                                        AttendeeId: null,
                                        //Password: field.data.Password,
                                        Phone: field.data.Phone,
                                        PhoneCountryCode: field.data.PhoneCountryCode ? field.data.PhoneCountryCode : '',
                                        Country: field.data.Country ? field.data.Country : '',
                                        FormType: field.data.FormType ? field.data.FormType : 'FREE',
                                        RegistrationType: field.data.RegistrationType ? field.data.RegistrationType : { ColorCode: "", RegistrationType: "Attendee", RegistrationTypeId: null },
                                        Company: field.data.Company,
                                        Designation: field.data.Designation,
                                        Profile: field.data.Profile,
                                        ProfilePictureURL: profileUrl ? profileUrl : '',
                                        Website: field.data.Website,
                                        SocialLinks: [
                                            { Facebook: '' },
                                            { GooglePlus: '' },
                                            { LinkedIn: '' },
                                            { Twitter: '' }
                                        ],
                                        Tags: (field.data.Tags ? field.data.Tags : ''),
                                        MailSent: false,
                                        IsVerified: true,
                                        IsPublished: true,
                                        UserRoles: [{
                                            RoleID: 10,
                                            RoleName: "AppUser"
                                        }],
                                        //CreatedDate: new Date(),
                                        //LastModifiedDate: new Date()
                                    }
                                    let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                                    let headers = {
                                        "Content-Type": "application/json",
                                        'Authorization': `Bearer ${accessToken}`,
                                        "x-api-key": DeleteAttendeeApiKey
                                    }
                                    let requestData = {
                                        "key": {
                                            "instanceId": "OA_UAT",
                                            "clientId": Session_Client_Id,
                                            "eventId": Session_Event_Id
                                        },
                                        "data": docObj,
                                        "sendMail": 0
                                    };
                                    axios.post(AddSingleAttendeeAPI, requestData, { headers: headers }).then(function (res) {
                                        if (res.status == 200) {
                                            resolve({ status: 200, message: 'Data Added.', Id: res.data.data.UserId })
                                        }
                                        else {
                                            resolve({ status: 500, message: 'Data Not Added.' })
                                        }

                                    }).catch(function (error) {
                                        //console.log('Error adding attendee:', error)
                                        reject(error)
                                    })
                                }).catch(function (error) {
                                    //console.log('download url '+error)                
                                })
                            }).catch(function (error) {
                                //console.log('imgae upload '+error)                
                            })
                        } else {
                            let docObj = {
                                Name: field.data.FirstName.trim() + ' ' + field.data.LastName.trim(),
                                FirstName: field.data.FirstName.trim(),
                                LastName: field.data.LastName.trim(),
                                Email: field.data.Email.toLowerCase().trim(),
                                AttendeeId: null,
                                //Password: field.data.Password,
                                Phone: field.data.Phone,
                                PhoneCountryCode: field.data.PhoneCountryCode ? field.data.PhoneCountryCode : '',
                                Country: field.data.Country ? field.data.Country : '',
                                FormType: field.data.FormType ? field.data.FormType : 'FREE',
                                RegistrationType: field.data.RegistrationType ? field.data.RegistrationType : { ColorCode: "", RegistrationType: "Attendee", RegistrationTypeId: null },
                                Company: field.data.Company,
                                Designation: field.data.Designation,
                                Profile: field.data.Profile,
                                ProfilePictureURL: '',
                                Website: field.data.Website,
                                SocialLinks: [
                                    { Facebook: '' },
                                    { GooglePlus: '' },
                                    { LinkedIn: '' },
                                    { Twitter: '' }
                                ],
                                Tags: (field.data.Tags ? field.data.Tags : ''),
                                MailSent: false,
                                IsVerified: true,
                                IsPublished: true,
                                UserRoles: [{
                                    RoleID: 10,
                                    RoleName: "AppUser"
                                }],
                                //CreatedDate: new Date(),
                                //LastModifiedDate: new Date()
                            }
                            if (field.data.UserRoles && field.data.UserRoles.length) { docObj.UserRoles = field.data.UserRoles; }
                            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                            let headers = {
                                "Content-Type": "application/json",
                                //'Authorization': `Bearer ${accessToken}`
                                "x-api-key": DeleteAttendeeApiKey
                            }
                            let requestData = {
                                "key": {
                                    "instanceId": "OA_UAT",
                                    "clientId": Session_Client_Id,
                                    "eventId": Session_Event_Id
                                },
                                "data": docObj,
                                "sendMail": 0
                            };
                            axios.post(AddSingleAttendeeAPI, requestData, { headers: headers }).then(function (res) {
                                if (res.status == 200) {
                                    resolve({ status: 200, message: 'Data Added.', Id: res.data.data.UserId })
                                }
                                else {
                                    resolve({ status: 500, message: 'Data Not Added.' })
                                }

                            }).catch(function (error) {
                                //console.log('Error adding attendee:', error)
                                reject(error)
                            })
                        }

                        //})
                    } else {
                        resolve({ status: 500, message: 'Email Already Exist!.', AttendeeDetail: doc.data() })
                    }

                }).catch(function (error) {
                    //console.log('Error getting attendee:', error)
                    reject(error)
                })
            }
        })
    },
    addAttendeeExt(context, field) {
        return new Promise((resolve, reject) => {
            if (field.data.Email == '') {
                resolve({ status: 500, message: 'Enter proper email!.' })
            } else {
                attendeeRef.where("Email", "==", field.data.Email.toLowerCase().trim()).get().then(function (snapShot) {
                    let doc = snapShot.docs[0];
                    if (snapShot.empty) {
                        var profileUrl = "";
                        if (field.data.file != null || field.data.file != undefined) {
                            const file = field.data.file
                            let metadata = {
                                'contentType': file.type
                            }
                            storageRef.child(cn + '/Attendee/profileImage/' + (new Date().getTime()) + "_" + file.name).putString(field.data.ProfilePictureURL, 'data_url').then(function (snapshot) {
                                snapshot.ref.getDownloadURL().then(function (url) {
                                    profileUrl = url.toString();
                                    let docObj = {
                                        Name: field.data.FirstName.trim() + ' ' + field.data.LastName.trim(),
                                        FirstName: field.data.FirstName.trim(),
                                        LastName: field.data.LastName.trim(),
                                        Email: field.data.Email.toLowerCase().trim(),
                                        AttendeeId: null,
                                        //Password: field.data.Password,
                                        Phone: field.data.Phone,
                                        PhoneCountryCode: field.data.PhoneCountryCode ? field.data.PhoneCountryCode : '',
                                        Country: field.data.Country ? field.data.Country : '',
                                        FormType: field.data.FormType ? field.data.FormType : 'FREE',
                                        RegistrationType: field.data.RegistrationType ? field.data.RegistrationType : { ColorCode: "", RegistrationType: "Attendee", RegistrationTypeId: null },
                                        Company: field.data.Company,
                                        Designation: field.data.Designation,
                                        Profile: field.data.Profile,
                                        ProfilePictureURL: profileUrl ? profileUrl : '',
                                        Website: field.data.Website,
                                        SocialLinks: [
                                            { Facebook: '' },
                                            { GooglePlus: '' },
                                            { LinkedIn: '' },
                                            { Twitter: '' }
                                        ],
                                        Tags: (field.data.Tags ? field.data.Tags : ''),
                                        MailSent: false,
                                        IsVerified: true,
                                        IsPublished: true,
                                        UserRoles: [{
                                            RoleID: 10,
                                            RoleName: "AppUser"
                                        }],
                                        //CreatedDate: new Date(),
                                        //LastModifiedDate: new Date()
                                        MappedLocations: field.data.MappedLocations ? field.data.MappedLocations : [],
                                        CheckinRoles: field.data.CheckinRoles ? field.data.CheckinRoles : [],
                                        Username: field.data.Username ? field.data.Username : "",
                                        DomainArea: field.data.DomainArea ? field.data.DomainArea : "",
                                        BaseLab: field.data.BaseLab ? field.data.BaseLab : "",
                                        CheckinPrimaryRole: field.data.DefaultCheckinRole ? field.data.DefaultCheckinRole : "",
                                        AllowRemoteCheckin: field.data.AllowRemoteCheckin,
                                        Password: defaultPassword,
                                        forceChangePassword: true,
                                        DesignationId: field.data.DesignationId ? field.data.DesignationId : "",
                                    }
                                    let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                                    let headers = {
                                        "Content-Type": "application/json",
                                        'Authorization': `Bearer ${accessToken}`,
                                        "x-api-key": DeleteAttendeeApiKey
                                    }
                                    let requestData = {
                                        "key": {
                                            "instanceId": "OA_UAT",
                                            "clientId": Session_Client_Id,
                                            "eventId": Session_Event_Id,
                                            "validateUsername": field.enableCheckinModule ? true : false
                                        },
                                        "data": [docObj],
                                        "sendMail": 0
                                    };
                                    axios.post(AddAttendeeAPI, requestData, { headers: headers }).then(function (res) {
                                        debugger;
                                        if (res.status == 200) {
                                            if (res.data && res.data.data && res.data.data.status == 0) {
                                                resolve({ status: 200, message: 'Data Added.' })
                                            } else if (res.data && res.data.data && res.data.data.status == -25) {
                                                resolve({ status: 500, message: 'Username already exists.' })
                                            } else if (res.data && res.data.data && res.data.data.status == -35) {
                                                resolve({ status: 500, message: 'Email already exists.' })
                                            }
                                            // if (res.data && res.data && res.data.data && res.data.data.status == 0) {
                                            //     resolve({ status: 200, message: 'Data Added.', Id: res.data.data.UserId })
                                            // } else if (res.data && res.data && res.data.data && res.data.data.status == -25) {
                                            //     resolve({ status: 500, message: 'Username already exists.', Id: res.data.data.UserId })
                                            // } else if (res.data && res.data && res.data.data && res.data.data.status == -35) {
                                            //     resolve({ status: 500, message: 'Email already exists.', Id: res.data.data.UserId })
                                            // }
                                        }
                                        else {
                                            resolve({ status: 500, message: 'Data Not Added.' })
                                        }

                                    }).catch(function (error) {
                                        //console.log('Error adding attendee:', error)
                                        reject(error)
                                    })
                                }).catch(function (error) {
                                    //console.log('download url '+error)                
                                })
                            }).catch(function (error) {
                                //console.log('imgae upload '+error)                
                            })
                        } else {
                            let docObj = {
                                Name: field.data.FirstName.trim() + ' ' + field.data.LastName.trim(),
                                FirstName: field.data.FirstName.trim(),
                                LastName: field.data.LastName.trim(),
                                Email: field.data.Email.toLowerCase().trim(),
                                AttendeeId: null,
                                //Password: field.data.Password,
                                Phone: field.data.Phone,
                                PhoneCountryCode: field.data.PhoneCountryCode ? field.data.PhoneCountryCode : '',
                                Country: field.data.Country ? field.data.Country : '',
                                FormType: field.data.FormType ? field.data.FormType : 'FREE',
                                RegistrationType: field.data.RegistrationType ? field.data.RegistrationType : { ColorCode: "", RegistrationType: "Attendee", RegistrationTypeId: null },
                                Company: field.data.Company,
                                Designation: field.data.Designation,
                                Profile: field.data.Profile,
                                ProfilePictureURL: '',
                                Website: field.data.Website,
                                SocialLinks: [
                                    { Facebook: '' },
                                    { GooglePlus: '' },
                                    { LinkedIn: '' },
                                    { Twitter: '' }
                                ],
                                Tags: (field.data.Tags ? field.data.Tags : ''),
                                MailSent: false,
                                IsVerified: true,
                                IsPublished: true,
                                UserRoles: [{
                                    RoleID: 10,
                                    RoleName: "AppUser"
                                }],
                                MappedLocations: field.data.MappedLocations ? field.data.MappedLocations : [],
                                CheckinRoles: field.data.CheckinRoles ? field.data.CheckinRoles : [],
                                Username: field.data.Username ? field.data.Username : "",
                                DomainArea: field.data.DomainArea ? field.data.DomainArea : "",
                                BaseLab: field.data.BaseLab ? field.data.BaseLab : "",
                                CheckinPrimaryRole: field.data.DefaultCheckinRole ? field.data.DefaultCheckinRole : "",
                                AllowRemoteCheckin: field.data.AllowRemoteCheckin,
                                Password: defaultPassword,
                                forceChangePassword: true,
                                DesignationId: field.data.DesignationId ? field.data.DesignationId : "",
                                
                                //CreatedDate: new Date(),
                                //LastModifiedDate: new Date()
                            }
                            if (field.data.UserRoles && field.data.UserRoles.length) { docObj.UserRoles = field.data.UserRoles; }
                            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                            let headers = {
                                "Content-Type": "application/json",
                                //'Authorization': `Bearer ${accessToken}`
                                "x-api-key": DeleteAttendeeApiKey
                            }
                            let requestData = {
                                "key": {
                                    "instanceId": "OA_UAT",
                                    "clientId": Session_Client_Id,
                                    "eventId": Session_Event_Id,
                                    "validateUsername": field.enableCheckinModule ? true : false
                                },
                                "data": [docObj],
                                "sendMail": 0
                            };
                            axios.post(AddAttendeeAPI, requestData, { headers: headers }).then(function (res) {
                                debugger;
                                if (res.status == 200) {
                                    if (res.data && res.data.data && res.data.data.status == 0) {
                                        resolve({ status: 200, message: 'Attendee added.' })
                                    } else if (res.data && res.data.data && res.data.data.status == -25) {
                                        resolve({ status: 500, message: 'Username already exists.' })
                                    } else if (res.data && res.data.data && res.data.data.status == -35) {
                                        resolve({ status: 500, message: 'Email already exists.' })
                                    }
                                }
                                else {
                                    resolve({ status: 500, message: 'Data Not Added.' })
                                }

                            }).catch(function (error) {
                                //console.log('Error adding attendee:', error)
                                reject(error)
                            })
                        }

                        //})
                    } else {
                        if(field.data.Username){
                            resolve({ status: 500, message: 'Username Already Exists!.', AttendeeDetail: doc.data() })
                        }else{
                            resolve({ status: 500, message: 'Email Already Exists!.', AttendeeDetail: doc.data() })
                        }
                        
                    }

                }).catch(function (error) {
                    //console.log('Error getting attendee:', error)
                    reject(error)
                })
            }
        })
    },
    getSettings(context) {
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("Settings").collection('Attendee').doc('AttendeeSettings').get().then(function (doc) {
                if (doc.exists) {
                    resolve(doc.data())
                } else {
                    resolve({ ShowMeetingButton: false })
                }

            })
        })
        return promise;
    },
    saveSettings(context, field) {
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("Settings").collection('Attendee').doc('AttendeeSettings').get().then(function (doc) {
                if (field.IsDefaultSettings) {
                    field.settingsData.DefaultSettingsLoaded = true;
                    context.dispatch('loadDefaultSettings');
                }
                if (doc.exists) {
                    con.eventDB.collection(cn).doc("Settings").collection('Attendee').doc('AttendeeSettings').update(field.settingsData)
                    resolve({ message: 'Data Updated.' })
                } else {
                    con.eventDB.collection(cn).doc("Settings").collection('Attendee').doc('AttendeeSettings').set(field.settingsData)
                    resolve({ message: 'Data Updated.' })
                }

            })
        })
        return promise;
    },
    loadDefaultSettings({ commit }) {
        let promise = new Promise((resolve, reject) => {
            maitmplateRef.doc("Reminder").get().then(function (mailtpl) {
                if (mailtpl.exists) {
                    resolve("Template Exists")
                }
                else {
                    con.instanceDB.doc("mailtpl").collection("ReminderMail").doc('Reminder').get().then(function (mailtplinstnc) {
                        if (mailtplinstnc.exists) {
                            maitmplateRef.doc('Reminder').set(mailtplinstnc.data()).then(function () {
                                resolve("Template Created from instance")
                            })
                        }
                        else {

                            maitmplateRef.doc('Reminder').set({ designJson: '', html: '', subject: '' }).then(function () {
                                resolve("Blank Template Created")
                            })
                        }
                    })
                }
            })
            con.instanceDB.doc("mailtpl").collection("welcomeMail").doc('UserSignup').get().then(function (mailtpl) {
                if (mailtpl.exists) {
                    resolve("Template Exists")
                }
                else {
                    con.instanceDB.doc("mailtpl").collection("welcomeMail").doc('UserSignup').get().then(function (mailtplinstnc) {
                        if (mailtplinstnc.exists) {
                            con.instanceDB.doc("mailtpl").collection("welcomeMail").doc('UserSignup').set(mailtplinstnc.data()).then(function () {
                                resolve("Template Created from instance")
                            })
                        }
                        else {

                            con.instanceDB.doc("mailtpl").collection("welcomeMail").doc('UserSignup').set({ designJson: '', html: '', subject: '' }).then(function () {
                                resolve("Blank Template Created")
                            })
                        }
                    })
                }
            })
        })
        return promise;
    },
    saveMail(context, field) {
        let html = field.html
        let subject = field.subject
        let tplpath = field.tplpath;
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("mailtpl").collection(tplpath.CollectionName).doc(tplpath.DocName).update({
                html: html,
                subject: subject
            }).then(function () {
                resolve({ message: "Mail Template Saved." })
            })
        })
        return promise;
    },
    getMailTemplate(context, tplpath) {
        var html = '';
        let subject = '';
        var count = 0;
        let promise = new Promise((resolve, reject) => {
            clientRef.get().then(function (clientDetail) {
                eventRef.get().then(function (eventDetail) {
                    //let StartDate = new Date(eventDetail.data().EventStartDate.seconds * 1000).toDateString() + " " + new Date(eventDetail.data().EventStartDate.seconds * 1000).toLocaleTimeString('en-US');
                    let EndDate = new Date(eventDetail.data().EventEndDate.seconds * 1000).toDateString() + " " + new Date(eventDetail.data().EventEndDate.seconds * 1000).toLocaleTimeString('en-US');

                    let StartDate = new Date(eventDetail.data().EventStartDate.seconds * 1000).toDateString()
                    let StartTime = new Date(eventDetail.data().EventEndDate.seconds * 1000).toLocaleTimeString('en-US')

                    let formatedText = {
                        CustomDomain: clientDetail.data().CustomDomain,
                        EventName: eventDetail.data().EventFullName,
                        Email: "Email",
                        Password: "Password",
                        FirstName: "First Name",
                        StartDate: StartDate,
                        StartTime: StartTime,
                        EndDate: EndDate,
                        EventAccessCode: atob(eventDetail.data().defaultEP),
                        EventAccessURL: `${clientDetail.data().CustomDomain}/#${eventDetail.data().EventId}`,
                        EventId: eventDetail.data().EventId,
                        //addtocalendarStartDate: addtocalendarStartDate,
                        //addtocalendarEndDate: addtocalendarEndDate,
                        EventBanner: eventDetail.data().EventBanner,
                        ClientName: clientDetail.data().ClientName,
                        ClientAddress: "Client address if present"
                    };
                    let Sesion_EventAccessType = ls.getSessionValueByKey("Sesion_EventAccessType");
                    let reminderMailDoc = Sesion_EventAccessType == 'Use Common Event Passcode' ? 'ReminderEventAccess' : 'Reminder';
                    con.eventDB.collection(cn).doc("mailtpl").collection(tplpath.CollectionName).doc(tplpath.DocName).get().then(function (mailtpl) {
                        if (mailtpl.exists) {
                            let sourcehtml = (mailtpl.data().html ? mailtpl.data().html : '')
                            let template = Handlebars.compile(sourcehtml);
                            let formatedhtml = template(formatedText);
                            html = (formatedhtml ? formatedhtml : 'Template not set!')
                            subject = (mailtpl.data().subject ? mailtpl.data().subject : null)
                            resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                        } else {
                            con.instanceDB.doc("mailtpl").collection(tplpath.CollectionName).doc(tplpath.DocName).get().then(function (mailtplinstnc) {
                                if (mailtplinstnc.exists) {
                                    maitmplateRef.doc(reminderMailDoc).set({ html: mailtplinstnc.data().html, subject: mailtplinstnc.data().subject }).then(function () {
                                        let sourcehtml = (mailtplinstnc.data().html ? mailtplinstnc.data().html : '')
                                        let template = Handlebars.compile(sourcehtml);
                                        let formatedhtml = template(formatedText);
                                        html = (formatedhtml ? formatedhtml : 'Template not set!')
                                        subject = (mailtplinstnc.data().subject ? mailtplinstnc.data().subject : null)
                                        resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                                    })
                                } else {
                                    html = 'Template not set!'
                                    subject = null
                                    sourcehtml = null
                                    resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                                }

                            })
                        }

                    })
                })
            })
        }) // end of promise

        return promise;
    },
    sendMailOLD(context, field) {
        let promise = new Promise((resolve, reject) => {
            const headers = {
                "Content-Type": "application/json"
            }
            var requestData = {};
            if (field.type == "Announcement") {
                requestData = {
                    "instanceID": "OA_UAT",
                    "clientID": Session_Client_Id,
                    "eventID": Session_Event_Id,
                    "userIdList": field.data,
                    "templateName": "Announcement"
                }
            } else {
                requestData = {
                    "instanceID": "OA_UAT",
                    "clientID": Session_Client_Id,
                    "eventID": Session_Event_Id,
                    "userIdList": field.data
                }
            }

            axios.post(BULKEMAILAPIURL, requestData, { headers: headers }).then((response) => {
                resolve({ status: 200, message: 'Mail sent to Users' })
            })
                .catch((error) => { })

        }) // end of promise

        return promise;

    },
    sendMail(context, field) {
        let promise = new Promise((resolve, reject) => {
            const headers = {
                "Content-Type": "application/json"
            }
            var requestData = {};
            requestData = {
                key: {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                    "recipientType": "Attendee",
                    "templatePath": `/mailtpl/${field.tplpath.CollectionName}/${field.tplpath.DocName}`
                },
                data: field.data
            }

            axios.post(BULKMAILAPINEW, requestData, { headers: headers }).then((response) => {
                resolve({ status: 200, message: 'Mail sent to Users' })
            })
                .catch((error) => { })

        }) // end of promise

        return promise;

    },
    async getAutoId(context) {
        //let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function (doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function () {
                        con.instanceDB.doc("AutoID").get().then(function (doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        let AutoId = await promise;
        AutoId = AutoId * 1000;
        return await AutoId.toString();
    },
    generateNumber(context, numberLength) {
        const random = new Random(); // uses the nativeMath engine
        //const value = random.hex(numberLength);
        const value = random.integer(100000, 999999);
        return value.toString();
    },
    getAllbusinessCardExchange(context) {
        return new Promise((resolve, reject) => {
            let markers = []
            con.eventDB.collection(cn).doc("Analytics").collection("UserAction")
                .where("page", "==", "/exhibitorshall")
                .where("actionType", "==", "view")
                //.where("Timestamp",">", new Date("September 16, 2020 09:30").getTime())
                //.where("Timestamp","<", new Date("September 16, 2020 21:30").getTime())
                //.orderBy("timestamp", "desc")
                //.startAt(new Date("September 16, 2020 09:30"))
                //.endAt(new Date("September 16, 2020 21:30"))
                .get()
                .then(querySnapshot => {
                    console.log(querySnapshot.docs.length)
                    querySnapshot.docs.forEach(doc => {
                        markers.push(doc.data())
                    })
                    resolve(markers)
                }).catch(function (error) {
                    //console.log('Error getting attendee:', error)
                    reject(error)
                })

        })
    },
    copySpeakerFromAttendee(context, rows) {
        return new Promise((resolve, reject) => {
            let alluserscount = rows.length;
            let count = 0;
            let updatecount = 0;
            rows.forEach(row => {
                speakerRef.where("Email", "==", row.Email.toLowerCase().trim()).get().then(function (snapShot) {
                    let docObj = {
                        Name: `${row.FirstName.trim()} ${row.LastName.trim()}`,
                        Company: row.Company ? row.Company : "",
                        CreatedDate: new Date(),
                        Designation: row.Designation ? row.Designation : "",
                        Email: row.Email.toLowerCase().trim(),
                        FirstName: row.FirstName.trim(),
                        Group: row.Group ? row.Group : "",
                        LastModifiedDate: new Date(),
                        LastName: row.LastName.trim(),
                        Phone: row.Phone ? row.Phone : "",
                        PhoneCountryCode: row.PhoneCountryCode ? row.PhoneCountryCode : '',
                        Profile: row.Profile ? row.Profile : "",
                        IsPublished: row.IsPublished,
                        ProfilePictureURL: row.ProfilePictureURL ? row.ProfilePictureURL : "",
                        SpeakerId: row.AttendeeId,
                        Website: row.Website ? row.Website : "",
                        Resources: [],
                        UserRoles: [{
                            RoleID: 10,
                            RoleName: "AppUser"
                        },
                        {
                            RoleID: 11,
                            RoleName: "Speaker"
                        }
                        ],
                        SocialLinks: row.SocialLinks ? row.SocialLinks : []
                    }

                    if (snapShot.empty) {
                        speakerRef.doc(`${docObj.SpeakerId}`).set(docObj).then(function () {
                            attendeeRef.doc(`${docObj.SpeakerId}`).update({ IsSpeaker: true }).then(function () {
                                count++;
                                if (alluserscount == count + updatecount)
                                    resolve({ status: 200, message: 'Speaker Created: ' + count + ", Speaker Exist: " + updatecount + ", of total Attendee" + alluserscount })
                            })
                        })
                    } else {
                        updatecount++;
                        if (alluserscount == count + updatecount)
                            resolve({ status: 200, message: 'Speaker Created: ' + count + ", Speaker Exist: " + updatecount + ", of total Attendee " + alluserscount })
                    }

                })
            })
        })
    },

    removeMultiRecords(context, field) {
        return new Promise((resolve, reject) => {
            let totallength = field.data.length;
            let count = 0;
            clientRef.get().then(function (clientDetail) {
                var flag = false;
                var clientEmail = clientDetail.data().ClientEmail;
                for (var i = 0; i < field.data.length; i++) {
                    if (field.data[i].Email == clientEmail) {
                        flag = true;
                        break;
                    }
                }
                if (flag) {
                    reject({ status: 0, message: clientEmail + ' can not be deleted' })
                }
                else {
                    for (var i = 0; i < field.data.length; i++) {
                        let AttendeeId = field.data[i].AttendeeId
                        let Email = field.data[i].Email
                        context.dispatch('removeRecord', { AttendeeId: AttendeeId, Email: Email }).then(value => {
                            count = count + 1;
                            if (totallength == count)
                                resolve({ status: 200, message: 'Total ' + count + ' Records Deleted' })
                        })
                    }
                }
            })
        })
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": Session_Event_Id,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": null
            }
            let totallength = field.data.length;
            let count = 0;
            for (var i = 0; i < field.data.length; i++) {
                let data = field.data[i]
                requestData.data = { UserId: `${data.AttendeeId}` }
                axios.post(CheckUserValidAPI, requestData, { headers: headers }).then(snapShot => {
                    let doc = snapShot.data.result;
                    let MappedEvents = doc.MappedEvents ? doc.MappedEvents : {};
                    let clientEvents = MappedEvents[Session_Client_Id] ? MappedEvents[Session_Client_Id] : [];
                    let ThisEventIndex = clientEvents.indexOf(Session_Event_Id);
                    if (field.Status) {
                        if (ThisEventIndex === -1) {
                            clientEvents.push(Session_Event_Id)
                            MappedEvents[Session_Client_Id] = clientEvents
                        }
                    } else {
                        if (ThisEventIndex > -1) {
                            clientEvents.splice(ThisEventIndex, 1)
                            MappedEvents[Session_Client_Id] = clientEvents
                        }
                    }

                    requestData.data = {
                        UserId: `${data.UserId}`,
                        IsPublished: field.Status,
                        MappedEvents: MappedEvents
                    }
                    axios.post(UpdateUserAPI, requestData, { headers: headers }).then(response => {
                        userEventsRef.doc(`${doc.UserId}`).update({
                            EventIDs: field.Status ? firebase.firestore.FieldValue.arrayUnion(Session_Event_Id) : firebase.firestore.FieldValue.arrayRemove(Session_Event_Id),
                            //LastModifiedDate: new Date()
                        })
                        count = count + 1;
                        if (totallength == count)
                            resolve({ status: 200, message: 'Status Changed of ' + count + ' Record' })
                    }).catch(err => {
                        count = count + 1;
                        if (totallength == count)
                            resolve({ status: 200, message: 'Status Changed of ' + count + ' Record' })
                    })


                })
            }
        }) // end of promise
    },
    updateHideInList(context, field) {
        //console.log(field)
        debugger;
        return new Promise((resolve, reject) => {
            attendeeRef.doc(`${field.id}`).update({
                HideInList: field.HideInList,
                LastModifiedDate: new Date()
            })
                .then(function (doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function (error) {
                    reject(error)
                })
        })
    },
    updateHideInLeaderboard(context, field) {
        //console.log(field)
        debugger;
        return new Promise((resolve, reject) => {
            attendeeRef.doc(`${field.id}`).update({
                HideInLeaderboard: field.HideInLeaderboard,
                LastModifiedDate: new Date()
            })
                .then(function (doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function (error) {
                    reject(error)
                })
        })
    },
    removeRecord({ commit }, userDetail) {
        return new Promise((resolve, reject) => {
            clientRef.get().then(function (clientDetail) {
                var clientEmail = clientDetail.data().ClientEmail;
                if (userDetail.Email == clientEmail) {
                    reject({ status: 0, message: clientEmail + ' can not be deleted' })
                } else {
                    let requestData = {
                        "key": {
                            "instanceId": "OA_UAT",
                            "clientId": Session_Client_Id,
                            "eventId": Session_Event_Id
                        },
                        "data": [
                            {
                                "AttendeeId": userDetail.AttendeeId,
                                "Email": userDetail.Email,
                                "Action": "delete"
                            }
                        ]
                    };
                    let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                    const headers = {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${accessToken}`
                        //"x-api-key": DeleteAttendeeApiKey
                        //'MIME-Version': '1.0\r\n'
                    }
                    axios.post(DeleteAttendeeURL, requestData, { headers: headers })
                        .then((response) => {
                            if (response.data.status == 0) {
                                resolve({ status: 200, message: 'Record Deleted' })
                            } else {
                                reject({ status: 0, message: 'Record Not Deleted' })
                            }
                        })
                        .catch((error) => {
                            //console.log(error)
                            reject(error)
                        })
                }
            })
        })

    },
    resetPasswordForUser(context, field) {
        debugger;
        return new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                let headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "content-type": 'application/json'
                }
                let requestData = {
                    "data": {
                        "password": field.password,
                        "confirmPassword": field.password,
                        "userId": field.userId,
                    }
                }
                axios.post(ResetPasswordForUserAPI, requestData, { headers: headers }).then((response) => {
                    resolve({ status: 200, message: "Password Changed Succesfully" })
                }).catch((error) => {
                    console.log("error===========", error);
                    //console.log(error) 
                    resolve({ status: 500, message: "Password Not Changed" })
                })

            })
        })
    },
    getFirebaseAccessToken(context) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey("Session_AccessToken")
            resolve(accessToken);
            /*let headers = {
                "content-type": "application/json"
            }
            context.dispatch('getUserDetailbyId', {UserId:Session_UserId}).then( res => {
                let requestData = {
                  "emailId": res.Email,
                  "password": String(res.Password)
                }
                axios.post(FirebaseAuthApi, requestData, { headers: headers }).then((response) => {
                      let accessToken = response.data.accessToken
                      resolve(accessToken)
                })
            })*/
        })
    },
    getAnnouncementMailTemplate(context) {
        var html = '';
        let subject = '';
        var count = 0;
        let promise = new Promise((resolve, reject) => {
            clientRef.get().then(function (clientDetail) {
                eventRef.get().then(function (eventDetail) {
                    //let StartDate = new Date(eventDetail.data().EventStartDate.seconds * 1000).toDateString() + " " + new Date(eventDetail.data().EventStartDate.seconds * 1000).toLocaleTimeString('en-US');
                    let EndDate = new Date(eventDetail.data().EventEndDate.seconds * 1000).toDateString() + " " + new Date(eventDetail.data().EventEndDate.seconds * 1000).toLocaleTimeString('en-US');

                    let StartDate = new Date(eventDetail.data().EventStartDate.seconds * 1000).toDateString()
                    let StartTime = new Date(eventDetail.data().EventEndDate.seconds * 1000).toLocaleTimeString('en-US')

                    let formatedText = {
                        CustomDomain: clientDetail.data().CustomDomain,
                        EventName: eventDetail.data().EventFullName,
                        Email: "Email",
                        Password: "Password",
                        FirstName: "First Name",
                        StartDate: StartDate,
                        StartTime: StartTime,
                        EndDate: EndDate,
                        EventAccessCode: atob(eventDetail.data().defaultEP),
                        EventAccessURL: `${clientDetail.data().CustomDomain}/#${eventDetail.data().EventId}`,
                        EventId: eventDetail.data().EventId,
                        //addtocalendarStartDate: addtocalendarStartDate,
                        //addtocalendarEndDate: addtocalendarEndDate,
                        EventBanner: eventDetail.data().EventBanner,
                        ClientName: clientDetail.data().ClientName,
                        ClientAddress: "Client address if present"
                    };
                    let Sesion_EventAccessType = ls.getSessionValueByKey("Sesion_EventAccessType");
                    let announcementMailDoc = Sesion_EventAccessType == 'Use Common Event Passcode' ? 'AnnouncementEventAccess' : 'Announcement';
                    mailTemplateAccouncementRef.doc(announcementMailDoc).get().then(function (mailtpl) {
                        if (mailtpl.exists) {
                            let sourcehtml = (mailtpl.data().html ? mailtpl.data().html : '')
                            let template = Handlebars.compile(sourcehtml);
                            let formatedhtml = template(formatedText);
                            html = (formatedhtml ? formatedhtml : 'Template not set!')
                            subject = (mailtpl.data().subject ? mailtpl.data().subject : null)
                            resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                        } else {
                            con.instanceDB.doc("mailtpl").collection("AnnouncementMail").doc(announcementMailDoc).get().then(function (mailtplinstnc) {
                                if (mailtplinstnc.exists) {
                                    mailTemplateAccouncementRef.doc(announcementMailDoc).set({ html: mailtplinstnc.data().html, subject: mailtplinstnc.data().subject }).then(function () {
                                        let sourcehtml = (mailtplinstnc.data().html ? mailtplinstnc.data().html : '')
                                        let template = Handlebars.compile(sourcehtml);
                                        let formatedhtml = template(formatedText);
                                        html = (formatedhtml ? formatedhtml : 'Template not set!')
                                        subject = (mailtplinstnc.data().subject ? mailtplinstnc.data().subject : null)
                                        resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                                    })
                                } else {
                                    html = 'Template not set!'
                                    subject = null
                                    sourcehtml = null
                                    resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                                }

                            })
                        }

                    })
                })
            })
        }) // end of promise

        return promise;
    },
    getdefaultFilterCriterias(context) {
        return new Promise((resolve, reject) => {
            let fields = []
            let jsonObj;
            storageRef.child(`${cn}/Registration/DefaultRegFormSettings.JSON`).getDownloadURL().then(function (url) {
                axios.get(url.toString()).then(result => {
                    if (typeof result.data == 'string')
                        jsonObj = eval('(' + result.data + ')');
                    else if (typeof result.data == 'object')
                        jsonObj = result.data
                    else
                        jsonObj = null
                    for (var key in jsonObj) {
                        if (jsonObj.hasOwnProperty(key)) {
                            let options = [];
                            for (var k in jsonObj[key]) {
                                if (typeof jsonObj[key][k] == 'object') {
                                    for (var o in jsonObj[key][k]) {
                                        options.push(jsonObj[key][k][o].Name)
                                    }
                                }

                            }
                            let filedObj = {
                                FieldName: key == 'RegistrationType' ? `${key}.RegistrationType` : key,
                                DisplayLabel: key,
                                AllowMultiSelect: false,
                                Operator: '==',
                                Options: options
                            }
                            fields.push(filedObj)
                        }
                    }
                    resolve(fields)
                })
            })
        })
    },
    getdynamicFilterCriterias(context) {
        return new Promise((resolve, reject) => {
            let fields = []
            let jsonObj;
            storageRef.child(`${cn}/Registration/FormBuilderReg.json`).getDownloadURL().then(function (url) {
                axios.get(url.toString()).then(result => {
                    if (typeof result.data == 'string')
                        jsonObj = eval('(' + result.data + ')');
                    else if (typeof result.data == 'object')
                        jsonObj = result.data
                    else
                        jsonObj = null
                    for (var key in jsonObj) {
                        let options = [];
                        if (jsonObj[key].field_options && jsonObj[key].field_options.options) {
                            for (var o in jsonObj[key].field_options.options) {
                                options.push(jsonObj[key].field_options.options[o].label)
                            }
                        }
                        let filedObj = {
                            FieldName: jsonObj[key].label,
                            DisplayLabel: jsonObj[key].label,
                            AllowMultiSelect: false,
                            Operator: '==',
                            Options: options
                        }
                        fields.push(filedObj)
                    }
                    resolve(fields)
                })
            })
        })
    },
    setfilterCriterias(context, fields) {
        return new Promise((resolve, reject) => {
            let attendeeFilterRef = con.eventDB.collection(cn).doc("AttendeeList").collection("AttendeeSettings").doc('FilterSettings');
            attendeeFilterRef.set({ DynamicFields: fields }).then(() => {
                resolve({ status: 200, message: 'Data Added' })
            }).catch(err => { reject(err); })
        })
    },
    getSavedfilterCriterias(context) {
        return new Promise((resolve, reject) => {
            let attendeeFilterRef = con.eventDB.collection(cn).doc("AttendeeList").collection("AttendeeSettings").doc('FilterSettings');
            attendeeFilterRef.get().then(doc => {
                resolve(doc.data())
            }).catch(err => { reject(err); })
        })
    },
    generateQR(context, ids) {
        return new Promise((resolve, reject) => {
            let markers = [];
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },
                data: {
                    type: 'Attendee',
                    ids: ids
                }
            };

            if (ids && ids.length)
                requestData.data = { type: 'Attendee', ids: ids }
            else
                requestData.data = { type: 'Attendee' }

            axios.post(generateQR, requestData, { headers: headers }).then(function (res) {
                if (res.data.length) {
                    resolve({ status: 200, message: "QR generated Successfully.", data: res.data })
                } else {
                    resolve({ status: 500, message: "Unable to generate QR!" })
                }

            }).catch(function (error) {
                reject(error)
            })
        })
    },
    resetPasswordForCheckinUser(context, field) {
        return new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                let headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "content-type": 'application/json'
                }
                let requestData = {
                    "key": {
                        "eventId": Session_Event_Id,
                        "clientId": Session_Client_Id,
                        "instanceId": "OA_UAT"
                    },
                    "data": {
                        "password": field.password,
                        "confirmPassword": field.password,
                        "userId": field.userId,
                        "forceChangePassword": field.forceChangePass ? field.forceChangePass : false
                    }
                }
                axios.post(ResetPasswordForCheckinUserAPI, requestData, { headers: headers }).then((response) => {
                    resolve({ status: 200, message: "Password Changed Succesfully" })
                }).catch((error) => {
                    console.log("error===========", error);
                    //console.log(error) 
                    resolve({ status: 500, message: "Password Not Changed" })
                })

            })
        })
    },
}